import * as React from 'react';
import Container from '@mui/material/Container';
import Hero from 'components/Hero.tsx';
import { Outlet } from "react-router";
import HotelNotification from 'components/Hotel/HotelNotification';
import RegistryNotification from 'components/Registry/RegistryNotification';

/**
 * Fonts
 * Myriad Variable Concept - Light SemiExtended
 * #E2774A
 * Boundless
 * #E2774A
 * Myriad Variable Concept - Light SemiExtended
 * #E97C3B
 * #F98F3C
 * #FEAD47
 * #FBC488
 * Myriad Variable Concept - Light SemiExtended - Italic
 * #FBC488
 * Myriad Variable Concept - Light SemiExtended
 * #806A61
 * 
 * # <AboutUs/>
 */

const styles = {
  rootContainer: {
      padding: {xs: 0},
      align: "center",
    }
 };

 export default function Home() {
  return (
    <Container sx={styles.rootContainer}>
        <Hero/>
        <RegistryNotification />
        <Outlet/>
    </Container>
  );
}
